import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { VelicinaStav } from './velicina-stav';
import { ActivatedRoute, Router } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-velicina-stav-update',
  templateUrl: './velicina-stav-update.component.html'
})
export class VelicinaStavUpdateComponent 
extends BaseUpdateComponent<VelicinaStav>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

    

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc('ValutaID', Validators.required, 'required', 'DOKUMENTSTAVKA.VALUTAID.VALIDATION.REQUIRED');
  }
}
